import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Button } from 'semantic-ui-react';

/**
 * Renders a sign-out button
 */
export function SignOutButton({ className }) {
  const auth = useAuth();

  const handleLogout = () => {
    auth.signoutRedirect();
  };

  return (
    <Button className={className} onClick={handleLogout}>
      <i className='sign out icon icon-inline' />
      Sign out
    </Button>
  );
}
